import axios from "axios";
import { getModuleApiBase } from "./config";

function getInstanceConfig(accessToken, accountId, moduleId, instanceId, env) {
  const url = `${getModuleApiBase()}/accounts/${accountId}/modules/${moduleId}/instances/${instanceId}`;
  return axios
    .get(url, {
      headers: {
        "X-ABTasty-Token": accessToken,
        "X-ABTasty-Account": accountId,
        "X-ABTasty-Environment": env,
      }
    })
    .then(response => response.data.config)
    .then(data => JSON.parse(data));
}

function getInstanceSource(accessToken, accountId, moduleId, instanceId, version, env) {
  const url = `${getModuleApiBase()}/accounts/${accountId}/modules/${moduleId}/instances/${instanceId}/sources?version=${version}`;
  return axios
    .get(url, {
      headers: {
        "X-ABTasty-Token": accessToken,
        "X-ABTasty-Account": accountId,
        "X-ABTasty-Environment": env,
      }
    })
    .then(response => response.data)
    .then(data => {
      return data.script;
    });
}

function getModuleInstance(accessToken, accountId, moduleId, env) {
  const url = `${getModuleApiBase()}/accounts/${accountId}/modules/${moduleId}/instances`;
  return axios
    .get(url, {
      headers: {
        "X-ABTasty-Token": accessToken,
        "X-ABTasty-Account": accountId,
        "X-ABTasty-Environment": env,
      }
    })
    .then(response => response.data[0]);
}

function postModuleInstance(accessToken, accountId, moduleId, env) {
  const url = `${getModuleApiBase()}/accounts/${accountId}/modules/${moduleId}/instances`;
  return axios
    .post(
      url,
      { scope: "account" },
      {
        headers: {
          "X-ABTasty-Token": accessToken,
          "X-ABTasty-Account": accountId,
          "X-ABTasty-Environment": env,
        }
      }
    )
    .then(response => response.data);
}

export default {
  getInstanceConfig,
  getInstanceSource,
  getModuleInstance,
  postModuleInstance
};
